import { post } from '../../../../../shared/utils/http';

import { initialiseCommonStore } from '../../../../../shared/components/react/CommonDataStore/actions';
import { COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS } from '../../../../../shared/components/react/CommonDataStore/actionTypes';
import mainSocket from '../../../../../shared/services/mainSocketClass';

import { updateMetaData } from '../../../../../shared/components/react/MetaDataStore/actions';

import { buildSpectateUrl } from '../../../../../spa/Utils/Spectate';

import {
    COMMON_DATA_LIST_EVENTS_ERROR,
    COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS,
    COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES,
} from '../actions/commonDataListEventsActionsTypes';

export const commonDataListEventsErrorOccurred = bool => {
    return {
        type: COMMON_DATA_LIST_EVENTS_ERROR,
        errorOccurred: bool,
    };
};

export const getWidgetEvents = (wsEventListener, postURL, postParams) => {

    return async (dispatch) => {
        try {

            const response = await post(
                buildSpectateUrl(postURL),
                postParams
            );
            if (!response.ok) {
                dispatch(commonDataListEventsErrorOccurred(true));

                return;
            }

            const data = await response.json();
            dispatch([
                updateMetaData({matchRequestLimit: data.match_request_limit}),
                initialiseCommonStore(data.events),
                startListeningForWsUpdates(data.selection_pointers),
                widgetEvents(data.event_order),
            ]);

            mainSocket.onWsEventUpdate(wsEventListener);
        } catch (e) {
            dispatch(commonDataListEventsErrorOccurred(true));
        }
    };
};

export const widgetEvents = (events) => {
    return {
        type: COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS,
        events,
    };
};

export const startListeningForWsUpdates = (events) => {
    return {
        type: COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES,
        events,
    };
};

export const updateCommonStoreWsData = wsData => {
    return {
        type: COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS,
        wsData: wsData,
    };
};
